// src/components/vendor/StatsCards.jsx
import React from 'react';
import { Grid, Card, CardContent, Typography, Box, Stack } from '@mui/material';
import {
  Inventory,
  ShoppingCart,
  People,
  AttachMoney,
  TrendingUp,
  TrendingDown,
} from '@mui/icons-material';

const StatsCards = ({ stats }) => {
  const cards = [
    {
      title: 'Total Products',
      value: stats?.totalProducts || 0,
      icon: <Inventory />,
      color: '#2196f3',
      change: '+12',
      trend: 'up',
    },
    {
      title: 'Total Orders',
      value: stats?.totalOrders || 0,
      icon: <ShoppingCart />,
      color: '#4caf50',
      change: '+8',
      trend: 'up',
    },
    {
      title: 'Total Customers',
      value: stats?.totalCustomers || 0,
      icon: <People />,
      color: '#ff9800',
      change: '+5',
      trend: 'up',
    },
    {
      title: 'Total Revenue',
      value: `$${stats?.totalRevenue?.toFixed(2) || '0.00'}`,
      icon: <AttachMoney />,
      color: '#d32f2f',
      change: '+15',
      trend: 'up',
    },
  ];

  return (
    <Grid container spacing={3}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={3} key={card.title}>
          <Card sx={{ borderRadius: 3 }}>
            <CardContent>
              <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                <Typography variant="body2" color="text.secondary" fontWeight="600">
                  {card.title}
                </Typography>
                <Box
                  sx={{
                    p: 1,
                    borderRadius: 1,
                    bgcolor: `${card.color}15`,
                    color: card.color,
                  }}
                >
                  {card.icon}
                </Box>
              </Stack>
              <Typography variant="h4" fontWeight="bold" sx={{ mb: 0.5 }}>
                {card.value}
              </Typography>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                {card.trend === 'up' ? (
                  <TrendingUp sx={{ fontSize: 16, color: 'success.main' }} />
                ) : (
                  <TrendingDown sx={{ fontSize: 16, color: 'error.main' }} />
                )}
                <Typography
                  variant="caption"
                  color={card.trend === 'up' ? 'success.main' : 'error.main'}
                  fontWeight="600"
                >
                  {card.change}%
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  vs last month
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default StatsCards;